import React, { useState } from "react";
import { useInView } from "react-intersection-observer";
import { useTranslation } from "react-i18next";
import { FaEnvelope, FaMapMarkerAlt, FaPaperPlane } from "react-icons/fa";
import "./Contact.css";

const Contact = () => {
  const { t } = useTranslation();
  const [ref, inView] = useInView({ threshold: 0.1, triggerOnce: true });
  const [formData, setFormData] = useState({ name: "", email: "", subject: "", message: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const payload = {
      ...formData,
      date: new Date().toLocaleString("es-MX", { year: "numeric", month: "long", day: "numeric", hour: "2-digit", minute: "2-digit" }),
    };

    try {
      const res = await fetch("/.netlify/functions/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error("Failed to send");

      setSubmitStatus("success");
      setFormData({ name: "", email: "", subject: "", message: "" });
    } catch (error) {
      setSubmitStatus("error");
      console.error("Error sending email:", error);
    } finally {
      setIsSubmitting(false);
      setTimeout(() => setSubmitStatus(null), 5000);
    }
  };

  return (
    <section id="contact" className="section contact">
      <div className="container">
        <h2 className="section-title">{t("contact.title")}</h2>

        <div ref={ref} className="contact-content">
          <div className={`contact-info ${inView ? "fade-in" : ""}`}>
            <h3>{t("contact.description")}</h3>
            <div className="contact-details">
              <div className="contact-item">
                <div className="contact-icon" aria-hidden="true"><FaEnvelope /></div>
                <div className="contact-text">
                  <h4>{t("contact.email")}</h4>
                  <a href="mailto:marianovc251@gmail.com">marianovc251@gmail.com</a>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon" aria-hidden="true"><FaMapMarkerAlt /></div>
                <div className="contact-text">
                  <h4>{t("contact.location")}</h4>
                  <span>Chapa de Mota, Edo. Mex., México</span>
                </div>
              </div>
            </div>
          </div>

          <div className={`contact-form ${inView ? "fade-in" : ""}`} style={{ animationDelay: "0.2s" }}>
            <form onSubmit={handleSubmit} noValidate>
              <div className="form-group">
                <label htmlFor="contact-name" className="sr-only">{t("contact.namePlaceholder")}</label>
                <input type="text" id="contact-name" name="name" placeholder={t("contact.namePlaceholder")} value={formData.name} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <label htmlFor="contact-email" className="sr-only">{t("contact.emailPlaceholder")}</label>
                <input type="email" id="contact-email" name="email" placeholder={t("contact.emailPlaceholder")} value={formData.email} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <label htmlFor="contact-subject" className="sr-only">{t("contact.subjectPlaceholder")}</label>
                <input type="text" id="contact-subject" name="subject" placeholder={t("contact.subjectPlaceholder")} value={formData.subject} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <label htmlFor="contact-message" className="sr-only">{t("contact.messagePlaceholder")}</label>
                <textarea id="contact-message" name="message" placeholder={t("contact.messagePlaceholder")} value={formData.message} onChange={handleChange} required></textarea>
              </div>
              <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                <FaPaperPlane aria-hidden="true" /> {isSubmitting ? t("contact.sending") : t("contact.sendBtn")}
              </button>
              {submitStatus === "success" && <div className="alert success" role="alert">{t("contact.success")}</div>}
              {submitStatus === "error" && <div className="alert error" role="alert">{t("contact.error")}</div>}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
